module.exports = __webpack_public_path__ + "static/img/logo.ee8b506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 17